import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react-hooks/exhaustive-deps */
import { BackdropLoader, ExpandedTooltip, Icon, SummaryInfo, toast, DatePicker } from '@livable/saas-react-components';
import { Accordion, AccordionDetails, AccordionSummary, Alert, Button, Checkbox, FormControl, FormControlLabel, FormGroup, IconButton, InputAdornment, InputLabel, OutlinedInput, Paper, Typography, Skeleton } from '@mui/material';
import { useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import RangeDatePicker from 'src/components/general/RangeDatePicker';
import DropFileUploader from 'src/components/shared/DropFileUploader';
import { useStore } from 'src/stores';
import { billSchema } from 'src/utils/formValidation/Allocations';
import TableModal from '../TableModal';
import UtilityCredential from 'src/components/allocations/AllocationUtility/UtilityCredential';
import { isValueNumber } from 'src/utils/typeValidators';
import { AssociatedVendorModal } from 'src/components/shared/AssociatedVendor/modal';
import useAllocationUtilityStyles from '../styles';
import AttachBillFileModal from './AttachBillFileModal';
const AllocationForm = observer(props => {
  var _utility$bill, _utility$bill2, _utility$bill3, _utility$bill4, _utility$bill5, _utility$bill6, _utility$bill13, _utility$bill14;
  const classes = useAllocationUtilityStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const billId = props.billId,
    fromHistory = props.fromHistory,
    handleApprove = props.handleApprove,
    isUtilityLoading = props.isUtilityLoading,
    propertyId = props.propertyId,
    selectedCycleStartDate = props.selectedCycleStartDate,
    utility = props.utility,
    utilityBillStatus = props.utilityBillStatus,
    utilityName = props.utilityName,
    utilityUpdateTimestamp = props.utilityUpdateTimestamp,
    fetchDefaultChargeOnDate = props.fetchDefaultChargeOnDate;
  const billInitialValues = {
    amount: ((_utility$bill = utility.bill) === null || _utility$bill === void 0 ? void 0 : _utility$bill.amount) || 0,
    commonAreaDeduction: utility.commonAreaDeduction,
    date: {
      endDate: ((_utility$bill2 = utility.bill) === null || _utility$bill2 === void 0 ? void 0 : _utility$bill2.endDateOnly) || '',
      startDate: ((_utility$bill3 = utility.bill) === null || _utility$bill3 === void 0 ? void 0 : _utility$bill3.startDateOnly) || ''
    },
    goodWillDeduction: utility.bill !== null && ((_utility$bill4 = utility.bill) === null || _utility$bill4 === void 0 ? void 0 : _utility$bill4.goodwillDeduction) >= 0 ? (_utility$bill5 = utility.bill) === null || _utility$bill5 === void 0 ? void 0 : _utility$bill5.goodwillDeduction : utility.defaultGoodwillDeduction
  };
  const utilityCad = isValueNumber(utility.commonAreaDeduction) && utility.commonAreaDeduction >= 0 ? utility.commonAreaDeduction : 5;
  const batchQueue = store.allocations.batchQueue;
  const allocationBatchId = batchQueue[0];
  const batchIdForUtility = store.allocations.allocationBatchIdForUtility.get(allocationBatchId) === utility.utilityId;
  const inBatchQueue = batchQueue.find(id => id === batchIdForUtility);
  const isBatchIsLoading = store.allocations.batched.includes(allocationBatchId) ? false : batchIdForUtility && allocationBatchId || inBatchQueue;
  const isDisabled = fromHistory || utility.isEditable === false;
  const isFileShared = !!(utility !== null && utility !== void 0 && (_utility$bill6 = utility.bill) !== null && _utility$bill6 !== void 0 && _utility$bill6.isShared);
  const selectedBillingCycleId = store.allocations.selectedBillingCycleId;
  const getFileId = () => {
    var _utility$bill7, _utility$bill8, _utility$bill9, _utility$bill0;
    return (_utility$bill7 = utility.bill) !== null && _utility$bill7 !== void 0 && _utility$bill7.redactedFileId ? (_utility$bill8 = utility.bill) === null || _utility$bill8 === void 0 ? void 0 : _utility$bill8.redactedFileId : (_utility$bill9 = utility.bill) !== null && _utility$bill9 !== void 0 && _utility$bill9.fileId ? (_utility$bill0 = utility.bill) === null || _utility$bill0 === void 0 ? void 0 : _utility$bill0.fileId : '';
  };
  const getFilePreviewLink = () => {
    var _utility$bill1, _utility$bill10, _utility$bill11, _utility$bill12;
    return (_utility$bill1 = utility.bill) !== null && _utility$bill1 !== void 0 && _utility$bill1.redactedFileId ? store.files.getFilePreviewLink({
      fileId: (_utility$bill10 = utility.bill) === null || _utility$bill10 === void 0 ? void 0 : _utility$bill10.redactedFileId
    }) : (_utility$bill11 = utility.bill) !== null && _utility$bill11 !== void 0 && _utility$bill11.fileId ? store.files.getFilePreviewLink({
      fileId: (_utility$bill12 = utility.bill) === null || _utility$bill12 === void 0 ? void 0 : _utility$bill12.fileId
    }) : '';
  };

  // const [billSettingsAccepted, setBillSettingsAccepted] = useState(false);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    openBillModal = _useState2[0],
    setOpenBillModal = _useState2[1];
  const _useState3 = useState(isFileShared),
    _useState4 = _slicedToArray(_useState3, 2),
    isBillVisible = _useState4[0],
    setIsBillVisible = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDateSet = _useState6[0],
    setIsDateSet = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isExpanded = _useState8[0],
    setIsExpanded = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isFileLoading = _useState0[0],
    setIsFileLoading = _useState0[1];
  const _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isLoading = _useState10[0],
    setIsLoading = _useState10[1];
  const _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isReinitialize = _useState12[0],
    setIsReinitialize = _useState12[1];
  const _useState13 = useState(getFileId()),
    _useState14 = _slicedToArray(_useState13, 2),
    fileId = _useState14[0],
    setFileId = _useState14[1];
  const _useState15 = useState(getFilePreviewLink()),
    _useState16 = _slicedToArray(_useState15, 2),
    filePreviewLink = _useState16[0],
    setFilePreviewLink = _useState16[1];
  const _useState17 = useState(''),
    _useState18 = _slicedToArray(_useState17, 2),
    fileName = _useState18[0],
    setFileName = _useState18[1];
  const _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2),
    fileSize = _useState20[0],
    setFileSize = _useState20[1];

  // const [modalIsOpen, setModalIsOpen] = useState(false);
  const _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    customChargeOnDate = _useState22[0],
    setCustomChargeOnDate = _useState22[1];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _useState23 = useState('Charge on date'),
    _useState24 = _slicedToArray(_useState23, 2),
    datePickerLabel = _useState24[0],
    setDatePickerLabel = _useState24[1];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _useState25 = useState(null),
    _useState26 = _slicedToArray(_useState25, 2),
    defaultChargeOnDateValue = _useState26[0],
    setDefaultChargeOnDateValue = _useState26[1];
  const _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    updateBillChargeOnDateTrigger = _useState28[0],
    setUpdateBillChargeOnDateTrigger = _useState28[1];
  const updateBillChargeOnDate = async (billIdExt, chargeOnDate) => {
    return store.appfolioBillsApi.postBillSettingsAsync.run({
      billId: billIdExt,
      chargeOnDate: chargeOnDate,
      propertyId: propertyId
    }).then(postBillSettingsAsyncResp => {
      if (postBillSettingsAsyncResp !== null && postBillSettingsAsyncResp !== void 0 && postBillSettingsAsyncResp.isSuccessful) {
        if (chargeOnDate === null) {
          toast('success', {
            body: [t('Bill charge on date cleared!')]
          });
        } else {
          toast('success', {
            body: [t('Bill charge on date updated!')]
          });
        }
      } else {
        toast('error', {
          body: [t('While updating bill charge on date!')]
        });
      }
    }).finally(() => setUpdateBillChargeOnDateTrigger(prev => !prev));
  };
  const isDisabledApprove = isDisabled || isFileLoading || utilityBillStatus === 'PendingCompletion' || utilityBillStatus === 'TableReady';
  const getFileAttached = async data => {
    const resp = await store.allocations.getFileAttachedAsync.run(data);
    return resp;
  };
  const getFileInfo = async data => {
    const resp = await store.files.getFileInfoAsync.run(data);
    return resp;
  };
  const updateUtilityBill = data => store.allocations.updateUtility(store.allocations.selectedBillingCycleId + utility.utilityId, _objectSpread(_objectSpread({}, utility), {}, {
    bill: _objectSpread(_objectSpread({}, utility.bill), data)
  }));
  const postBillCreated = async data => {
    const resp = await store.allocations.postBillCreatedAsync.run(data);
    if (resp && resp.isSuccessful) {
      updateUtilityBill(data);
      toast('success', {
        body: [t('general.successfully_created')]
      });
    }
    return resp;
  };
  const putBillUpdated = async data => {
    const resp = await store.allocations.putBillUpdatedAsync.run(data);
    if (resp && resp.isSuccessful) {
      updateUtilityBill(data);
      toast('success', {
        body: [t('general.successfully_updated')]
      });
    }
    return resp;
  };
  const updateAllocationTable = () => {
    setIsExpanded(true);
    store.allocations.addToQueue({
      billingCycleId: store.allocations.selectedBillingCycleId,
      id: store.allocations.selectedBillingCycleId + propertyId + utility.utilityId,
      propertyId,
      utilityId: utility.utilityId
    });
  };
  const saveBillId = resp => {
    if (!resp) return;
    if (fileId) {
      getFileAttached({
        billId: resp.response,
        fileId,
        isShared: isBillVisible
      });
    }
    if (store.company.companyFeatureStore.isAppfolio) {
      if (customChargeOnDate !== null) {
        updateBillChargeOnDate(resp.response, customChargeOnDate);
      }
    }
    return updateAllocationTable();
  };
  const updateBillId = () => {
    if (fileId) {
      getFileAttached({
        billId,
        fileId,
        isShared: isBillVisible
      });
    }
    return updateAllocationTable();
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: billInitialValues,
    onSubmit: async values => {
      setIsLoading(true);
      const data = {
        amount: parseFloat(values.amount),
        endDateOnly: moment(values.date.endDate).format(moment.HTML5_FMT.DATE),
        goodWillDeduction: parseFloat(values.goodWillDeduction),
        isExcluded: true,
        startDateOnly: moment(values.date.startDate).format(moment.HTML5_FMT.DATE)
      };
      if (billId) {
        putBillUpdated(_objectSpread(_objectSpread({}, data), {}, {
          id: billId
        })).then(updateBillId).then(() => updateUtilityBill(data)).then(() => store.allocations.addToQueue({
          billingCycleId: store.allocations.selectedBillingCycleId,
          id: store.allocations.selectedBillingCycleId + propertyId,
          propertyId
        })).finally(() => setIsLoading(false));
      } else {
        postBillCreated(_objectSpread(_objectSpread({}, data), {}, {
          billingCycleId: store.allocations.selectedBillingCycleId,
          propertyId,
          utilityId: utility.utilityId
        })).then(saveBillId).then(() => updateUtilityBill(data)).then(() => store.allocations.addToQueue({
          billingCycleId: store.allocations.selectedBillingCycleId,
          id: store.allocations.selectedBillingCycleId + propertyId,
          propertyId
        })).finally(() => setIsLoading(false));
      }
    },
    validationSchema: billSchema
  });
  const handlePresignedFileFeature = async response => {
    var _response$response;
    const fileNamePartials = (_response$response = response.response) === null || _response$response === void 0 ? void 0 : _response$response.fileName.split('.');
    const fileExtension = fileNamePartials[fileNamePartials.length - 1];
    if (['doc', 'docx'].includes(fileExtension)) {
      const requestFilePreviewLinkResp = await store.files.getRequestPreviewLinkAsync.run({
        fileId: response.response.fileId
      });
      if (requestFilePreviewLinkResp.isSuccessful) {
        setFilePreviewLink(requestFilePreviewLinkResp.response);
      }
    } else {
      const filePreviewLinkResp = await store.files.getPresignedFileDownloadUrlAsync.run({
        fileId: response.response.fileId,
        isPreview: true
      });
      if (filePreviewLinkResp !== null && filePreviewLinkResp !== void 0 && filePreviewLinkResp.isSuccessful) {
        setFilePreviewLink(filePreviewLinkResp.response);
      }
    }
  };
  const clearFileState = () => {
    setFileId('');
    setFileName('');
    setFilePreviewLink('');
    setIsBillVisible(false);
  };
  const fileCallback = async response => {
    if (response) {
      const _response$response2 = response.response,
        newFileId = _response$response2.fileId,
        newFileName = _response$response2.fileName,
        fileSizeMB = _response$response2.fileSizeMB;
      setFileId(newFileId);
      setFileName(newFileName);
      setFileSize(fileSizeMB);
      if (store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled) {
        await handlePresignedFileFeature(response);
      } else {
        var _newFileName$split$po;
        setFilePreviewLink(store.files.getFilePreviewLink({
          fileId: newFileId
        }, false, ".".concat(newFileName === null || newFileName === void 0 || (_newFileName$split$po = newFileName.split('.').pop()) === null || _newFileName$split$po === void 0 ? void 0 : _newFileName$split$po.toLowerCase())));
      }
    } else if (response === null) {
      clearFileState();
    }
    setIsBillVisible(isFileShared);
    setIsFileLoading(false);
  };
  useEffect(() => {
    const id = getFileId();
    if (utility.utilityId && id) getFileInfo({
      fileId: id
    }).then(fileCallback);
  }, [utility.utilityId]);
  useEffect(() => {
    setIsReinitialize(true);
  }, [(_utility$bill13 = utility.bill) === null || _utility$bill13 === void 0 ? void 0 : _utility$bill13.endDateOnly, (_utility$bill14 = utility.bill) === null || _utility$bill14 === void 0 ? void 0 : _utility$bill14.startDateOnly]);
  useEffect(() => {
    if (store.company.companyFeatureStore.isAppfolio) {
      if (!!billId && billId !== '') {
        const data = {
          billId,
          allocationCycleMonth: store.allocations.currentCycle.month,
          allocationCycleYear: store.allocations.currentCycle.year
        };
        store.appfolioBillsApi.getSettingsByBillIdV2Async.run(data).then(getSettingsByBillIdAsyncResp => {
          if (getSettingsByBillIdAsyncResp !== null && getSettingsByBillIdAsyncResp !== void 0 && getSettingsByBillIdAsyncResp.isSuccessful) {
            if (getSettingsByBillIdAsyncResp !== null && getSettingsByBillIdAsyncResp !== void 0 && getSettingsByBillIdAsyncResp.response) {
              const _getSettingsByBillIdA = getSettingsByBillIdAsyncResp.response,
                chargeOnDate = _getSettingsByBillIdA.chargeOnDate,
                defaultChargeOnDate = _getSettingsByBillIdA.defaultChargeOnDate;
              setCustomChargeOnDate(chargeOnDate);
              if (defaultChargeOnDate) {
                setDatePickerLabel("Charge on date will be set to ".concat(moment(defaultChargeOnDate).format('MM/DD/YYYY')));
                setDefaultChargeOnDateValue(defaultChargeOnDate);
              }
            }
          }
        });
      } else if (propertyId && fetchDefaultChargeOnDate && !(!!billId && billId !== '')) {
        // If billId is not provided, we fetch the default charge on date based on property
        const data = {
          propertyId,
          allocationCycleMonth: store.allocations.currentCycle.month,
          allocationCycleYear: store.allocations.currentCycle.year
        };
        store.appfolioPropertiesApi.getDefaultChargeOnDateAsync.run(data).then(getSettingsByBillIdAsyncResp => {
          if (getSettingsByBillIdAsyncResp !== null && getSettingsByBillIdAsyncResp !== void 0 && getSettingsByBillIdAsyncResp.isSuccessful) {
            setDefaultChargeOnDateValue(getSettingsByBillIdAsyncResp.response);
          }
        });
      }
    }
  }, [billId, fetchDefaultChargeOnDate, updateBillChargeOnDateTrigger]);
  useEffect(() => {
    if (getFileId()) getFileInfo({
      fileId: getFileId()
    }).then(fileCallback);
    return () => {
      formik.setValues(billInitialValues);
      setIsReinitialize(true);
      setFileId('');
      setFileName('');
      setFilePreviewLink('');
    };
  }, [selectedBillingCycleId]);
  const isCycleFromPreviousMonth = () => {
    if (!formik.values.date.startDate) {
      const today = moment().toDate();
      const cycleStartDate = moment(selectedCycleStartDate).toDate();
      return moment(cycleStartDate).isBefore(today, 'month');
    }
  };
  const handleLoading = () => setIsFileLoading(true);
  const onChange = e => {
    formik.handleChange(e);
  };
  const onKeyDown = e => {
    if (e.keyCode == 13) {
      e.preventDefault();
    }
  };
  const endAdornment = text => /*#__PURE__*/React.createElement(InputAdornment, {
    position: "end",
    type: "infoTooltip"
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: text,
    placement: "top"
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
    type: "question"
  }))));
  const calculateFormFromModal = values => {
    setIsLoading(true);
    setIsDateSet(true);
    formik.setValues(values);
    setTimeout(() => {
      setIsDateSet(false);
      formik.handleSubmit();
    }, 0);
  };
  const handleBillVisible = async () => {
    setIsBillVisible(!isBillVisible);
    if (billId) {
      setIsLoading(true);
      await getFileAttached({
        billId,
        fileId: fileId,
        isShared: !isBillVisible
      });
      setIsLoading(false);
    }
    updateUtilityBill({
      isShared: !Boolean(isBillVisible)
    });
  };
  const dropFileUploaderCallback = async id => {
    if (id === null) {
      await store.files.deleteFileAsync.run({
        fileId: fileId
      });
      setFileId(id);
      updateUtilityBill({
        fileId: id
      });
      if (billId) {
        await getFileAttached({
          billId,
          fileId: id,
          isShared: null
        });
      }
      fileCallback(id);
    } else {
      setFileId(id);
      updateUtilityBill({
        fileId: id
      });
      if (billId) {
        getFileAttached({
          billId,
          fileId: id,
          isShared: isBillVisible
        });
      }
      getFileInfo({
        fileId: id
      }).then(fileCallback);
      setOpenBillModal(true);
    }
    store.allocations.setIsAttachBillFileModalOpen(utility.utilityId, '');
  };
  const editFileCallback = async newId => {
    setFileId(newId);
    updateUtilityBill({
      redactedFileId: newId
    });
    if (billId) {
      var _utility$bill15;
      getFileAttached({
        billId,
        fileId: utility === null || utility === void 0 || (_utility$bill15 = utility.bill) === null || _utility$bill15 === void 0 ? void 0 : _utility$bill15.fileId,
        redactedFileId: newId,
        isShared: isBillVisible
      });
    }
    getFileInfo({
      fileId: newId
    }).then(fileCallback);
  };
  const Drop = () => /*#__PURE__*/React.createElement(DropFileUploader
  // billSettingsAccepted={billSettingsAccepted}
  , {
    callback: dropFileUploaderCallback,
    editFileCallback: editFileCallback,
    disabled: isDisabled,
    fileName: fileName,
    fileSize: fileSize,
    filePreviewLink: filePreviewLink,
    isFileUploadingAccepted: store.files.isFileUploadingAccepted,
    isUtilityForm: true,
    label: t('allocations.attach_bill_file')
    // setModalIsOpen={setModalIsOpen}
    ,
    tooltipText: "".concat(t('allocations.livable_transparency'), " ").concat(t('allocations.you_share_bill')),
    uploadStartedCallback: handleLoading,
    validator: formik,
    isDisabledParent: isDisabled,
    isPreviewForm: true,
    calculateFormFromModal: calculateFormFromModal,
    selectedCycleStartDate: selectedCycleStartDate,
    utility: utility,
    openBillModal: openBillModal,
    setOpenBillModal: setOpenBillModal
  });
  const getLabel = () => {
    if (customChargeOnDate) return 'Charge on date';else if (defaultChargeOnDateValue || store.allocations.propertyDefaultChargeOnDate) return moment(defaultChargeOnDateValue !== null && defaultChargeOnDateValue !== void 0 ? defaultChargeOnDateValue : store.allocations.propertyDefaultChargeOnDate).format('MM/DD/YYYY');
    return 'Charge on date';
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, false && /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "error",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Charges will not be pushed to AppFolio because the vendor is not linked."), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "Please select an associated vendor to restore connection."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(AssociatedVendorModal, {
    utilityProviderId: utility.utilityId
  }))), /*#__PURE__*/React.createElement("form", {
    className: classes.allocationForm,
    onSubmit: formik.handleSubmit,
    "data-tut": "reactour__allocation-form"
  }, false ? /*#__PURE__*/React.createElement(UtilityCredential, null) : null, /*#__PURE__*/React.createElement("div", {
    className: classes.groupWrapper
  }, fileId ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, t('allocations.attach_bill_file')), /*#__PURE__*/React.createElement("div", {
    className: classes.groupWrapperContent
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(fileId ? 'attached' : '', " ").concat(classes.attachFile)
  }, /*#__PURE__*/React.createElement(Drop, null), fileId && /*#__PURE__*/React.createElement("div", {
    className: classes.visibilitySetting
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: isBillVisible,
      onChange: () => handleBillVisible()
    }),
    label: t('allocations.is_bill_visible')
  })), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: "top",
    title: t('allocations.is_bill_visible_hint'),
    type: "grey"
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
    state: "info",
    type: "question"
  }))))))) : /*#__PURE__*/React.createElement("div", {
    className: classes.groupWrapperContent
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(fileId ? 'attached' : '', " ").concat(classes.attachFile)
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.active, " ").concat(classes.dropArea, " ").concat(isDisabled ? 'disabled' : '')
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "p",
    variant: "h4"
  }, t('allocations.attach_bill_file')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.attachFileText,
    variant: "body2"
  }, t('allocations.attach_bill_description')), /*#__PURE__*/React.createElement(Button, {
    'custom-attribute': '08-attach-file',
    className: classes.attachFileButton,
    disabled: isDisabled,
    onClick: () => store.allocations.setIsAttachBillFileModalOpen(utility.utilityId, utilityName),
    size: "small",
    variant: "text"
  }, t('allocations.attach_file'))), /*#__PURE__*/React.createElement(AttachBillFileModal, {
    dropComponent: /*#__PURE__*/React.createElement(Drop, null),
    dropFileUploaderCallback: dropFileUploaderCallback,
    propertyId: propertyId,
    utility: utility
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.groupWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Enter bill details"), /*#__PURE__*/React.createElement("div", {
    className: classes.groupWrapperContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.datePicker
  }, !isDateSet && /*#__PURE__*/React.createElement(RangeDatePicker, {
    toDate: formik.values.date.endDate ? moment(formik.values.date.endDate).toDate() : '',
    fromDate: formik.values.date.startDate ? moment(formik.values.date.startDate).toDate() : '',
    disabled: isDisabled,
    handleDateChange: dates => {
      formik.setFieldTouched(formik.values.date);
      formik.handleChange({
        target: {
          id: 'date',
          value: dates
        }
      });
    },
    id: "date",
    label: t('allocations.select_dates_range'),
    maxDate: moment(store.allocations.currentCycle.endDateOnly).add(store.company.companyFeatureStore.isAppfolio ? 15 : 1, 'days').toDate(),
    reinitialize: isReinitialize,
    setIsReinitialize: setIsReinitialize,
    showPreviousMonths: isCycleFromPreviousMonth()
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.field, " ").concat(classes.billField)
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "amount"
  }, t('allocations.bill_value')), /*#__PURE__*/React.createElement(OutlinedInput, {
    disabled: isDisabled,
    endAdornment: endAdornment(t('allocations.should_be_decimal')),
    error: formik.touched.amount && Boolean(formik.errors.amount),
    id: "amount",
    label: t('allocations.bill_value'),
    onChange: onChange,
    onKeyDown: onKeyDown,
    placeholder: "0.00",
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, "$"),
    type: "float",
    value: formik.values.amount
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.flexBreakMd
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.fieldsSm
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.field
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "cad"
  }, t('allocations.cad')), /*#__PURE__*/React.createElement(OutlinedInput, {
    defaultValue: utilityCad,
    disabled: true,
    endAdornment: endAdornment(t('allocations.cad_hint')),
    id: "cad",
    key: utility.commonAreaDeduction,
    label: t('allocations.cad'),
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "lock-locked"
    })),
    type: "text"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.field
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "goodWillDeduction"
  }, t('allocations.gwd')), /*#__PURE__*/React.createElement(OutlinedInput, {
    disabled: isDisabled,
    endAdornment: endAdornment(t('allocations.gwd_hint')),
    error: formik.touched.goodWillDeduction && Boolean(formik.errors.goodWillDeduction),
    id: "goodWillDeduction",
    inputProps: {
      maxLength: 3
    },
    label: t('allocations.gwd'),
    onChange: onChange,
    onKeyDown: onKeyDown,
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }),
    placeholder: "0.00",
    type: "float",
    value: formik.values.goodWillDeduction
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.calculateButton
  }, isFileLoading || isUtilityLoading ? /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: Boolean(isFileLoading || isUtilityLoading)
  })) : /*#__PURE__*/React.createElement(Button, {
    disabled: isDisabled || !formik.isValid || isFileLoading,
    type: "submit",
    variant: "contained",
    'custom-attribute': '504-allocation-utility'
  }, t('allocations.calculate'))), /*#__PURE__*/React.createElement("div", {
    className: classes.calculateButton
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: isDisabledApprove,
    onClick: handleApprove,
    variant: "contained",
    'custom-attribute': '505-allocation-utility'
  }, t('allocations.approval')), store.company.companyFeatureStore.isAppfolio ? /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: "top",
    title: t('allocations.approval_hint'),
    type: "grey"
  }, /*#__PURE__*/React.createElement(IconButton, {
    'custom-attribute': '506-allocation-utility'
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "info",
    type: "question"
  }))) : null)))), store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement("div", {
    className: classes.groupWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.groupWrapperContent
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.datePicker, " ").concat(classes.field, " ").concat(classes.customChargeOnDateDatePicker)
  }, store.appfolioBillsApi.postBillSettingsAsync.inProgress || store.appfolioBillsApi.getSettingsByBillIdAsync.inProgress || store.appfolioPropertiesApi.getDefaultChargeOnDateAsync.inProgress ? /*#__PURE__*/React.createElement(Skeleton, {
    variant: "rectangular",
    animation: "wave",
    height: 48,
    width: 260
  }) : isDisabled ? /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "Charge_On_Date"
  }, t('Charge on date')), /*#__PURE__*/React.createElement(OutlinedInput, {
    value: !!customChargeOnDate && customChargeOnDate !== null && customChargeOnDate !== '' ? moment(customChargeOnDate).format('MM/DD/YYYY') : null,
    disabled: true,
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "calendar-picker",
      state: "lightGrey"
    })),
    id: "Charge_On_Date",
    label: 'Charge_On_Date',
    type: "text"
  })) : /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: 'top',
    title: customChargeOnDate ? '' : datePickerLabel,
    type: 'success-bold-dark'
  }, /*#__PURE__*/React.createElement(DatePicker, {
    format: "MM/dd/yyyy",
    label: getLabel(),
    onChange: date => {
      if (store.appfolioBillsApi.postBillSettingsAsync.inProgress || store.appfolioBillsApi.getSettingsByBillIdAsync.inProgress || store.appfolioPropertiesApi.getDefaultChargeOnDateAsync.inProgress) return;
      const formatedDate = date === null || date === '' ? null : moment(date).format('YYYY-MM-DD');
      setCustomChargeOnDate(formatedDate);
      if (!!billId && billId !== '') {
        updateBillChargeOnDate(billId, formatedDate);
      }
    },
    value: customChargeOnDate !== null ? moment(customChargeOnDate).toDate() : null
  }), ''), !isDisabled && /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    style: {
      width: '48px',
      height: '48px',
      marginLeft: '6px'
    },
    disabled: customChargeOnDate === null || customChargeOnDate === undefined,
    onClick: () => {
      setCustomChargeOnDate(null);
      if (!!billId && billId !== '') {
        updateBillChargeOnDate(billId, null);
      }
    },
    'custom-attribute': '858-property-utilities-setup-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "close"
  })), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: "top",
    title: t("Set the date to post the charge or credit — if you leave it blank, we’ll use date from property settings. If it's not set - we’ll use today’s date."),
    type: "grey"
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
    state: "info",
    type: "question"
  }))))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: Boolean(isFileLoading || isLoading || isUtilityLoading || isBatchIsLoading)
  }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Accordion, {
    className: classes.detailsTable,
    expanded: isExpanded
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    "aria-controls": "allocation-details",
    expandIcon: /*#__PURE__*/React.createElement(Icon, {
      fontSize: "large",
      type: "arrow-line-right"
    }),
    id: "allocation-details",
    onClick: () => setIsExpanded(prevValue => !prevValue)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('allocations.view_ratio_billed_units_table')), /*#__PURE__*/React.createElement("div", {
    className: classes.totalSummary
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('allocations.ratio_billed_total'), "\xA0"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "$", utility.ratioBilledTotal || 0)))), /*#__PURE__*/React.createElement(AccordionDetails, {
    key: store.account.profilesSumId
  }, /*#__PURE__*/React.createElement(TableModal, {
    allocations: utility === null || utility === void 0 ? void 0 : utility.allocations,
    key: utilityUpdateTimestamp
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.summary
  }, /*#__PURE__*/React.createElement(SummaryInfo, {
    padding: 0,
    shades: 200,
    showRecovery: true,
    summaryData: {
      'Allocated:': "$".concat(utility.allocated || 0),
      'Bill total:': "$".concat(utility.billTotal || 0),
      'Deductions:': "".concat(utility.deductions || 0, "%"),
      'Recovery:': "".concat(utility.recovery || 0, "%")
    }
  }))));
});
export default AllocationForm;